import principalSample from "../assets/principal.png"; // placeholder image
import SEO from "../components/SEO";

export default function About() {
  return (
    <div className="container section">
      <SEO
        title="About | Sri Venkateswara Degree & PG College, Nellore"
        description="Learn about the history, vision, mission, and leadership of Sri Venkateswara Degree & PG College, Nellore."
      />
      <h2 className="text-3xl md:text-4xl font-semibold text-neutral-900 mb-6">About Us</h2>

      <section className="mb-12">
        <h3 className="text-2xl font-semibold text-neutral-900">History & Vision</h3>
        <p className="mt-4 leading-relaxed text-neutral-700">
          Sri Venkateswara Group of Colleges, Nellore, was established with the noble vision of providing quality higher education.
        </p>
        <ul className="list-disc ml-6 mt-4 space-y-2 text-neutral-700">
          <li>Founded in 1992 by Dr. Peddisetty Suneel Kumar, Ph.D.</li>
          <li>Expanded to Degree College in 1994</li>
          <li>Offers UG and PG programmes in Science, Commerce, Management & IT</li>
        </ul>
      </section>

      <section className="flex flex-col md:flex-row items-start gap-8">
        {/* <img src={principalSample} alt="Principal" className="w-full md:w-1/4 max-w-xs object-cover rounded-xl shadow-soft border border-neutral-200/70" /> */}
        <div className="flex-1">
          <h3 className="text-2xl font-semibold text-neutral-900">Principal’s Message</h3>
          <p className="mt-4 leading-relaxed text-neutral-700">
            Welcome to Sri Venkateswara Degree & PG College, Nellore. Our mission is to provide quality education at UG, and PG levels while nurturing knowledge, character, and social responsibility. We strive to create a supportive learning environment with modern infrastructure, experienced faculty, and opportunities for holistic development. We aim to empower students to excel in academics, professional life, and society, shaping them into responsible and competent citizens.
          </p>
          <p className="mt-4 font-semibold text-neutral-900">– Principal</p>
        </div>
      </section>
    </div>
  );
}
